import React from "react";
import SortIcon from "../../../assets/svg/sorting.svg";
import arrowleft from "../../../assets/svg/arrow-left.svg";
import arrowright from "../../../assets/svg/arrow-right.svg";
import Select from "react-select";
import filter from "../../../assets/svg/filter.svg";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import axios from "axios";
import apiUrl from "../../helpers/endpointservice";
import $ from "jquery";
import Pagination from "react-js-pagination";
import {
    applicationEnum,
    paginglist,
    paginglistDefault,
} from "../../custom/CommonJson";
import {
    logoutFunction,
    ToastMessageFailure,
    ToastMessageSuccess,
    Loader,
} from "../../custom/CommonFunction";
import {
    crossicon,
    FailedIcon,
    TickIcon,
    crossWhite,
    ManagerDropIcon,
    addapplication,
    applicationdelete,
    applicationname1,
    searchapplication,
    reseticon,
    RequiredIcon,
    saveapplication,
    applicationdescription,
    applicationurl,
    DeleteIcon,
    editiconred,
    roles,
    plusred,
} from "../../custom/ImageImport";
import moment from "moment";

class Application extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            isMobile600: false,
            isMobile380: false,
            isMobile1000: false,
            isLoadSpinner: false,
            isLoadSpinnerTable: true,
            idnumber: null,
            height: window.innerHeight,
            isAddSuccess: false,
            isAddFailure: false,
            applicationNameError: false,
            isDelete: false,
            isOwner: false,
            isCursor: false,
            isAdmin: false,
            isUpdateSuccess: false,
            isUpdateFailure: false,
            isFormValid: true,
            isView: false,
            isDeleteFail: false,
            applicationId: 0,
            isEdit: false,
            isModalClose: false,
            isAddowner: false,
            isAddadmin: false,
            isAddApp: false,
            sortBy: "applicationname",
            applicationname: "",
            sortOrder: "asc",
            applicationdescription: "",
            pagesize: 10,
            pagenumber: 1,
            isShowscreen: false,
            applicationExists: false,
            pagenumber: 1,
            pagination: {},
            deleteList: [],
            viewDelete: [],
            applicationList: [],
            id: null,
            isAddHide: false,
            applicationHeading: "",
            addeditApplication: {
                applicationName: "",
                appUrl: "",
                description: "",
                applicationId: null,
                actionBy: "admin",
                historyLogs: []
            },
            rolesList: [],
            roleChange: false,
            roleId: 0,
            roleName: "",
            usersList: [],
            deleteRoleList: [],
            applicationEnum: "",
            currentUserId: 0,
        };
        this.handleChangeSelect1 = this.handlerolesAction.bind(this);
    }
    componentDidMount() {
        this.setState({
            currentUserId: parseInt(localStorage.getItem("userId"))
        })
        const intervals = setInterval(() => {
            this.resize();
        }, 10);
        axios
            .get(apiUrl.GetUsers)
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({
                        usersList: response?.data,
                    });
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
            });
        this.getapplications(this.state.pagenumber);
    }

    getapplications = (pagenumber) => {
        axios
            .get(
                apiUrl.GetApplications +
                "?applicationname=" +
                this.state.applicationname +
                "&sortBy=" +
                this.state.sortBy +
                "&sortOrder=" +
                this.state.sortOrder +
                "&pagesize=" +
                this.state.pagesize +
                "&pagenumber=" +
                pagenumber
            )
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({
                        applicationList: response.data,
                    });
                }
                this.setState({ isLoadSpinnerTable: false });
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                this.setState({ isLoadSpinnerTable: false });
            });
    };

    logoutDirect = () => {
        window.location.href = process.env.REACT_APP_LOGOUT;
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.state.isMobile = true;
        } else {
            this.state.isMobile = false;
        }
        if (window.innerWidth < 600) {
            this.state.isMobile600 = true;
        } else {
            this.state.isMobile600 = false;
        }
        if (window.innerWidth < 380) {
            this.state.isMobile380 = true;
        } else {
            this.state.isMobile380 = false;
        }
        if (window.innerWidth < 300) {
            this.state.isMobile300 = true;
        } else {
            this.state.isMobile300 = false;
        }
        this.state.height = window.innerHeight;
        this.setState({});
    };

    sorting = () => {
        this.state.isLoadSpinnerTable = true;
        if (this.state.sortOrder == "asc") {
            this.state.sortOrder = "desc";
            this.state.pagenumber = 1;
        } else {
            this.state.sortOrder = "asc";
            this.state.pagenumber = 1;
        }
        this.setState({});
        this.getapplications(this.state.pagenumber);
    };

    handleclick = () => {
        this.state.isShowscreen = true;
        this.setState({});
    };

    handleFilterClear = (str) => {
        this.state[str] = "";
        this.state.pagenumber = 1;
        this.setState({});
        this.getapplications(1);
    };

    pageSize = (e) => {
        this.state.pagesize = e.value;
        this.state.pagenumber = 1;
        this.setState({});
        this.setState({ isLoadSpinnerTable: true });
        this.getapplications(this.state.pagenumber);
    };

    handleInputSearch = (e, val) => {
        this.state[val] = e.target.value;
        this.setState({});
        this.setState({});
    };

    handlePageChange = (pageNumber) => {
        this.state.pagenumber = pageNumber;
        this.state.deleteList = [];
        this.state.isLoadSpinnerTable = true;
        this.setState({});
        this.getapplications(this.state.pagenumber);
    };

    clearData = () => {
        this.setState({
            addeditApplication: {
                applicationName: "",
                appUrl: "",
                description: "",
                applicationId: null,
                actionBy: "admin",
                historyLogs: []
            },
        });
    };

    handleFilterSearch = () => {
        if (this.state.applicationname != "") {
            this.setState({
                isFormValid: true,
                isLoadSpinnerTable: true,
                pagenumber: 1,
            });
            this.getapplications(1);
            document.getElementById("closeSearch").click();
        } else {
            this.setState({ isFormValid: false });
        }
    };

    handleFilterClear = () => {
        this.state.applicationname = "";
        this.state.isLoadSpinnerTable = true;
        this.state.pagenumber = 1;
        this.setState({});
        this.getapplications(1);
    };

    handleViewData = (id) => {
        this.state.idnumber = id;
        this.setState({});
    };

    handleEditPage = (id, name) => {
        this.clearData();
        this.setState({
            isView: true,
            isAddApp: false,
            isEdit: false,
            applicationId: id,
            applicationNameError: false,
            isLoadSpinner: true,
            applicationEnum: name,
        });
        this.getviewData(id);
        this.handleViewDelete(id);

        let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("viewScreen")
        );
        myOffcanvas.show();
        this.setState({});
    };

    getviewData = (id) => {
        axios
            .get(apiUrl.ActionApplication + "/" + id)
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({
                        applicationHeading: response.data.applicationName,
                        addeditApplication: {
                            applicationName: response.data.applicationName,
                            description: response.data.description,
                            appUrl: response.data.appUrl,
                            users: response.data.users,
                            deleteAppUser: [],
                            historyLogs: response.data.historyLogs
                        },
                    });

                    if (response.data?.users?.length > 0) {
                        let data = [];

                        this.state.usersList.map((code) => {
                            if (
                                response.data?.users[0].users.filter((r) => r.id == code.id)
                                    ?.length == 0
                            ) {
                                data.push(code);
                            }
                        });
                        this.state.rolesList = data.map((code) => {
                            return {
                                value: code.id + "," + code.name + "," + code.value,
                                label: (
                                    <>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="align-middle text-center">
                                                        <img src={ManagerDropIcon} className="drop-icon" />
                                                    </td>
                                                    <td className="align-middle px-2">
                                                        <div>{code.value}</div>
                                                        <div>{code.name}</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </>
                                ),
                            };
                        });
                        this.setState({
                            roleId: response.data?.users[0].roleId,
                            roleName: response.data?.users[0].roleName,
                        });
                    }
                    if (response.data.applicationName != "") {
                        this.setState({ isAddHide: true });
                    } else {
                        this.setState({ isAddHide: false });
                    }
                    this.setState({ isLoadSpinner: false });
                }
            })
            .catch((error) => {
                this.setState({ isLoadSpinner: false });
                logoutFunction(error?.response?.status);
            });
    };

    roleChangeId = (Id, name) => {
        this.setState({ roleId: Id, roleName: name });
        this.changeRoles(Id);
    };

    handleEditApplication = () => {
        this.setState({ isLoadSpinner: true });

        $("#viewScreen").attr("data-bs-backdrop", "static");
        this.setState({ isEdit: true, isView: false, isAddApp: false });
        let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("viewScreen")
        );
        myOffcanvas.show();
        this.props.dispatch({ type: "EDIT_CANCEL", data: true });

        setTimeout(() => {
            this.setState({ isLoadSpinner: false });
        }, 500);
    };

    handleAddApplication = () => {
        this.clearData();
        this.setState({
            isView: false,
            isEdit: false,
            isAddApp: true,
            applicationNameError: false,
        });
        let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("viewScreen")
        );
        myOffcanvas.show();
        this.props.dispatch({ type: "EDIT_CANCEL", data: false });
    };

    handleMultipleEdit = () => {
        this.clearData();
        this.setState({
            isView: true,
            isEdit: false,
            isAddApp: false,
            applicationNameError: false,
            isLoadSpinner: true,
        });
        this.getviewData(this.state.idnumber);
        let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("viewScreen")
        );
        myOffcanvas.show();
        this.props.dispatch({ type: "EDIT_CANCEL", data: false });
    };

    handleCheckbox = (id) => {
        const { deleteList } = this.state;
        if (deleteList.length == 0) {
            deleteList.push(id);
        } else {
            if (deleteList && deleteList.filter((i) => i == id).length == 1) {
                deleteList.map((i, ind) => (i == id ? deleteList.splice(ind, 1) : ""));
            } else {
                deleteList.push(id);
            }
        }
        this.setState({});
    };

    handleViewDelete = (id) => {
        const { viewDelete } = this.state;
        if (viewDelete.length == 0) {
            viewDelete.push(id);
        } else {
            viewDelete.splice(0, 1, id);
        }
    };

    handleCheckboxTop = () => {
        let data = [];
        if (
            this.state.deleteList?.length !=
            this.state.applicationList?.application?.length &&
            this.state.deleteList?.length > 0 &&
            this.state.applicationList?.application?.length > 0
        ) {
            this.state.applicationList?.application.map((r) =>
                data.push(r.applicationId)
            );
        }
        if (
            this.state.deleteList?.length == 0 &&
            this.state.applicationList?.application?.length > 0
        ) {
            this.state.applicationList?.application.map((r) =>
                data.push(r.applicationId)
            );
        }
        if (
            this.state.deleteList?.length ==
            this.state.applicationList?.application?.length &&
            this.state.applicationList?.application?.length > 0
        ) {
            data = [];
        }
        this.state.deleteList = data;
        this.setState({});
    };

    handleInputAddEdit = (e, str) => {
        this.state.addeditApplication[str] = e.target.value;
        this.setState({});
    };

    handleAddEdit = () => {
        if (this.state.addeditApplication.applicationName?.trim() === "") {
            this.setState({
                applicationNameError: true,
            });
            document.getElementById("applicationNameId")?.focus();
        }
        if (this.state.addeditApplication.applicationName?.trim() !== "") {
            this.setState({
                applicationNameError: false,
            });
        }

        if (this.state.addeditApplication.applicationName?.trim() !== "") {
            if (this.state.isAddApp == true) {
                this.setState({ isLoadSpinner: true });
                axios
                    .get(
                        apiUrl.VerifyApplication +
                        this.state.addeditApplication.applicationName?.trim()
                    )
                    .then((response) => {
                        if (response?.status === 200) {
                            if (response?.data == true) {
                                document.getElementById("addEditApplication")?.click();
                                this.setState({
                                    isAddHide: false,
                                    applicationExists: false,
                                });
                                if (this.state.isAddApp == true) {
                                    let data = {
                                        applicationName:
                                            this.state.addeditApplication.applicationName?.trim(),
                                        appUrl: this.state.addeditApplication.appUrl?.trim(),
                                        description:
                                            this.state.addeditApplication.description?.trim(),
                                        actionBy: "admin",
                                    };
                                    this.postdata(data);
                                }
                                // if (this.state.isAddApp == false) {
                                //   let userIdVal = [];
                                //   this.state.addeditApplication.users?.map(
                                //     (r, ind) => (
                                //       (userIdVal = []),
                                //       r.users.length > 0
                                //         ? (r.users.map((s) => userIdVal.push(s.id)),
                                //           (r.userId = userIdVal))
                                //         : (r.userId = [])
                                //     )
                                //   );
                                //   this.state.addeditApplication.users?.map((s) => (s.users = []));
                                //   let data = {
                                //     applicationName:
                                //       this.state.addeditApplication.applicationName?.trim(),
                                //     appUrl: this.state.addeditApplication.appUrl?.trim(),
                                //     description: this.state.addeditApplication.description?.trim(),
                                //     appUser: this.state.addeditApplication.users,
                                //     deleteAppUser: this.state.addeditApplication.deleteAppUser,
                                //     actionBy: "admin",
                                //   };
                                //   this.putdata(data, this.state.applicationId);
                                // }
                                this.setState({ isAddHide: false });
                                this.setState({ isEdit: false, isAddApp: false });
                            } else {
                                this.setState({
                                    applicationExists: true,
                                    isLoadSpinner: false,
                                });
                                document.getElementById("applicationNameId")?.focus();
                            }
                        }
                    })
                    .catch((error) => {
                        this.setState({ isLoadSpinner: false });
                        logoutFunction(error?.response?.status);
                    });
            }
            if (this.state.isAddApp == false) {
                let userIdVal = [];
                this.state.addeditApplication.users?.map(
                    (r, ind) => (
                        (userIdVal = []),
                        r.users.length > 0
                            ? (r.users.map((s) => userIdVal.push(s.id)),
                                (r.userId = userIdVal))
                            : (r.userId = [])
                    )
                );
                this.state.addeditApplication.users?.map((s) => (s.users = []));
                let data = {
                    applicationName:
                        this.state.addeditApplication.applicationName?.trim(),
                    appUrl: this.state.addeditApplication.appUrl?.trim(),
                    description: this.state.addeditApplication.description?.trim(),
                    appUser: this.state.addeditApplication.users,
                    deleteAppUser: this.state.addeditApplication.deleteAppUser,
                    actionBy: "admin",
                };
                this.putdata(data, this.state.applicationId);
                this.setState({ isAddHide: false });
                this.setState({ isEdit: false, isAddApp: false });
            }
        }

        this.props.dispatch({ type: "EDIT_CANCEL", data: false });
    };

    handleCheckboxRolesAll = () => {
        let data = this.state.addeditApplication?.deleteAppUser?.filter(
            (s) => s.roleId == this.state.roleId
        )[0]?.userId;
        let data1 = this.state.addeditApplication?.users?.filter(
            (s) => s.roleId == this.state.roleId
        )[0]?.users;

        if ((data == undefined || data == []) && data1.length > 0) {
            let val = [];
            this.state.addeditApplication?.users?.map((s) =>
                s.roleId == this.state.roleId ? s.users?.map((z) => val.push(z.id)) : ""
            );
            let object = {
                roleId: this.state.roleId,
                roleName: this.state.roleName,
                userId: val,
                users: [],
            };
            this.state.addeditApplication?.deleteAppUser?.push(object);
        }
        if (data?.length > 0 && data1.length > 0) {
            let val = [];
            this.state.addeditApplication?.users?.map(
                (s) => (
                    s.roleId == this.state.roleId
                        ? s.users?.map((z) => val.push(z.id))
                        : "",
                    this.state.addeditApplication?.deleteAppUser?.map((s) =>
                        s.roleId == this.state.roleId ? (s.userId = val) : ""
                    )
                )
            );
        }
        if (data?.length == 0 && data1.length > 0) {
            let val = [];
            this.state.addeditApplication?.users?.map(
                (s) => (
                    s.roleId == this.state.roleId
                        ? s.users?.map((z) => val.push(z.id))
                        : "",
                    this.state.addeditApplication?.deleteAppUser?.map((s) =>
                        s.roleId == this.state.roleId ? (s.userId = val) : ""
                    )
                )
            );
        }
        if (data?.length === data1.length && data1.length > 0) {
            this.state.addeditApplication?.deleteAppUser?.map((s) =>
                s.roleId == this.state.roleId ? (s.userId = []) : ""
            );
        }
        this.setState({});
    };

    handleCheckboxRoles = (id) => {
        if (this.state.addeditApplication?.deleteAppUser?.length == 0) {
            let object = {
                roleId: this.state.roleId,
                roleName: this.state.roleName,
                userId: [id],
                users: [],
            };
            this.state.addeditApplication?.deleteAppUser?.push(object);
        } else {
            let object1 = {};
            this.state.addeditApplication?.deleteAppUser?.map((r) =>
                r.roleId == this.state.roleId
                    ? r.userId && r.userId.filter((i) => i == id).length == 1
                        ? r.userId?.map((i, ind) =>
                            i == id ? r.userId?.splice(ind, 1) : ""
                        )
                        : r.userId?.push(id)
                    : ((object1 = {
                        roleId: this.state.roleId,
                        roleName: this.state.roleName,
                        userId: [id],
                        users: [],
                    }),
                        this.state.addeditApplication?.deleteAppUser?.push(object1))
            );
        }
        this.setState({});
    };

    changeRoles = (Id) => {
        let data = [];
        let val = [];
        this.state.addeditApplication.users?.map((r) =>
            Id === r.roleId ? (val = r?.users) : ""
        );
        this.state.usersList.map((code) => {
            if (val?.filter((r) => r.id == code.id)?.length == 0) {
                data.push(code);
            }
        });
        this.state.rolesList = data.map((code) => {
            return {
                value: code.id + "," + code.name + "," + code.value,
                label: (
                    <>
                        <table>
                            <tbody>
                                <tr>
                                    <td className="align-middle text-center">
                                        <img src={ManagerDropIcon} className="drop-icon" />
                                    </td>
                                    <td className="align-middle px-2">
                                        <div>{code.value}</div>
                                        <div>{code.name}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </>
                ),
            };
        });
    };

    handleRoleIdRemove = () => {
        let data = [];
        this.state.addeditApplication?.deleteAppUser?.map((r, index) =>
            r.roleId == this.state.roleId
                ? (this.state.addeditApplication?.users?.map((s) =>
                    s.roleId == this.state.roleId
                        ? s.users?.map(
                            (z, ind) =>
                                r.userId?.filter(
                                    (a) => a == z.id && z.id != localStorage.getItem("userId")
                                ).length > 0
                                    ? ""
                                    : data.push(z),
                            (s.users = data)
                        )
                        : ""
                ),
                    this.state.addeditApplication?.deleteAppUser?.splice(index, 1))
                : ""
        );
        this.setState({});
        this.changeRoles(this.state.roleId);
    };

    handlerolesAction = (e) => {
        if (e[0]) {
            let val = this.state.usersList?.filter(
                (r) => r.id == parseInt(e[0]?.value.split?.(",")[0])
            );
            this.state.addeditApplication.users?.map((r) =>
                this.state.roleId === r.roleId ? r?.users.push(val[0]) : ""
            );
            this.changeRoles(this.state.roleId);
        }
    };

    postdata = (data) => {
        this.setState({ isLoadSpinner: true });
        axios
            .post(apiUrl.ActionApplication + "?userId=" + this.state.currentUserId, data)
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({
                        isAddSuccess: true,
                        isUpdateSuccess: false,
                        isDelete: false,
                    });
                    setTimeout(() => {
                        this.setState({ isAddSuccess: false });
                    }, 4000);
                    this.getapplications(this.state.pagenumber);
                    this.setState({
                        addeditApplication: {
                            applicationName: "",
                            appUrl: "",
                            description: "",
                            applicationId: null,
                            actionBy: "admin",
                        },
                    });
                } else {
                    this.setState({
                        isAddFailure: true,
                        isUpdateFailure: false,
                        isDeleteFail: false,
                    });
                    setTimeout(() => {
                        this.setState({ isAddFailure: false });
                    }, 4000);
                }
                this.setState({ isLoadSpinner: false });
            })
            .catch((error) => {
                this.setState({
                    isAddFailure: true,
                    isUpdateFailure: false,
                    isDeleteFail: false,
                });
                setTimeout(() => {
                    this.setState({ isAddFailure: false });
                }, 4000);
                logoutFunction(error?.response?.status);
                this.setState({ isLoadSpinner: false });
            });
    };

    putdata = (data, id) => {
        this.setState({ isLoadSpinner: true });
        axios
            .put(apiUrl.ActionApplication + "?appId=" + id + "&userId=" + this.state.currentUserId, data)
            .then((response) => {
                if (response?.status === 200) {
                    this.getapplications(this.state.pagenumber);
                    this.setState({
                        addeditApplication: {
                            applicationName: "",
                            appUrl: "",
                            description: "",
                            applicationId: null,
                            actionBy: "admin",
                        },
                    });
                    this.setState({
                        isUpdateSuccess: true,
                        isAddSuccess: false,
                        isDelete: false,
                    });
                    setTimeout(() => {
                        this.setState({ isUpdateSuccess: false });
                    }, 4000);
                } else {
                    this.setState({
                        isUpdateFailure: true,
                        isAddFailure: false,
                        isDeleteFail: false,
                    });
                    setTimeout(() => {
                        this.setState({ isUpdateFailure: false });
                    }, 4000);
                }
                this.setState({ isLoadSpinner: false });
            })
            .catch((error) => {
                this.setState({
                    isUpdateFailure: true,
                    isAddFailure: false,
                    isDeleteFail: false,
                });
                setTimeout(() => {
                    this.setState({ isUpdateFailure: false });
                }, 4000);
                logoutFunction(error?.response?.status);
                this.setState({ isLoadSpinner: false });
            });
    };

    DeleteYesViewDelete = () => {
        this.setState({ isLoadSpinner: true });
        let viewdeletedata = "";
        this.state.viewDelete?.map((r) => (viewdeletedata = r));
        axios
            .delete(
                apiUrl.ActionApplication +
                "?app_ids=" +
                viewdeletedata +
                "&action_by=admin" +
                "&userId=" + this.state.currentUserId
            )
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({ pagenumber: 1 });
                    this.getapplications(1);
                    this.CancelYes();
                    this.state.viewDelete = [];
                    this.setState({});
                    this.setState({
                        isDelete: true,
                        isUpdateSuccess: false,
                        isAddSuccess: false,
                    });
                    setTimeout(() => {
                        this.setState({ isDelete: false });
                    }, 4000);
                } else {
                    this.setState({
                        isDeleteFail: true,
                        isAddFailure: false,
                        isUpdateFailure: false,
                    });
                    setTimeout(() => {
                        this.setState({ isDeleteFail: false });
                    }, 4000);
                }
                this.setState({ isLoadSpinner: false });
            })
            .catch((error) => {
                this.setState({
                    isDeleteFail: true,
                    isAddFailure: false,
                    isUpdateFailure: false,
                });
                setTimeout(() => {
                    this.setState({ isDeleteFail: false });
                }, 4000);
                logoutFunction(error?.response?.status);
                this.setState({ isLoadSpinner: false });
            });
    };

    DeleteYes = () => {
        this.setState({ isLoadSpinner: true });

        let deleteData = "";
        let val = "";

        let dataId = this.state.applicationList?.application?.filter(
            (r) => r.application_enum == applicationEnum
        );

        this.state.deleteList?.map((r, idx) =>
            r != dataId[0]?.applicationId
                ? ((val = "," + r), (deleteData += val))
                : ""
        );

        let datasubstring = deleteData?.substring(1);

        axios
            .delete(
                apiUrl.ActionApplication +
                "?app_ids=" +
                datasubstring +
                "&action_by=admin" +
                "&userId=" + this.state.currentUserId
            )
            .then((response) => {
                if (response?.status === 200) {
                    this.getapplications(this.state.pagenumber);
                    this.state.deleteList = [];
                    this.setState({});
                    this.setState({
                        isDelete: true,
                        isUpdateSuccess: false,
                        isAddSuccess: false,
                    });
                    setTimeout(() => {
                        this.setState({ isDelete: false });
                    }, 4000);
                } else {
                    this.setState({
                        isDeleteFail: true,
                        isAddFailure: false,
                        isUpdateFailure: false,
                    });
                    setTimeout(() => {
                        this.setState({ isDeleteFail: false });
                    }, 4000);
                }
                this.setState({ isLoadSpinner: false });
            })
            .catch((error) => {
                this.setState({
                    isDeleteFail: true,
                    isAddFailure: false,
                    isUpdateFailure: false,
                });
                setTimeout(() => {
                    this.setState({ isDeleteFail: false });
                }, 4000);
                logoutFunction(error?.response?.status);
                this.setState({ isLoadSpinner: false });
            });
    };

    CancelYes = () => {
        this.setState({ isEdit: false, isView: false });
        document.getElementById("clearEditYes").click();
        $("#viewScreen").attr("data-bs-backdrop", "true");

        this.props.dispatch({ type: "EDIT_CANCEL", data: false });
    };

    showFilterSearch = () => {
        let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("searchScreen")
        );
        myOffcanvas.show();
        this.setState({ isFormValid: true });
    };

    showSearchScreen = () => {
        this.state.isAddHide = false;
        this.state.applicationNameError = false;
        this.setState({});
        this.clearData();

        this.setState({ isAddApp: true, isEdit: false, isView: false });
        let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("viewScreen")
        );
        myOffcanvas.show();
        this.props.dispatch({ type: "EDIT_CANCEL", data: false });
    };

    previousPage = () => {
        this.state.pagenumber = this.state.pagenumber - 1;
        this.setState({});
        this.getapplications(this.state.pagenumber);
    };

    nextPage = () => {
        this.state.pagenumber = this.state.pagenumber + 1;
        this.setState({});
        this.getapplications(this.state.pagenumber);
    };

    cancelToastMessage = () => {
        this.setState({
            isAddFailure: false,
            isUpdateFailure: false,
            isDeleteFail: false,
            isAddSuccess: false,
            isUpdateSuccess: false,
            isDelete: false,
        });
    };

    render() {
        const {
            sortBy,
            sortOrder,
            pagenumber,
            applicationList,
            isMobile,
            height,
            isMobile380,
            isView,
            isEdit,
            isAddFailure,
            isAddSuccess,
            isLoadSpinnerTable,
            isLoadSpinner,
            isAddApp,
            isDelete,
            deleteList,
            isDeleteFail,
            isUpdateFailure,
            isUpdateSuccess,
            isMobile300,
            isMobile600,
            isInputValid,
            isFormValid,
        } = this.state;
        return (
            <>
                <Loader loader={isLoadSpinner || isLoadSpinnerTable} />
                <div
                    className={isMobile ? "" : this.props.sideMenu ? "ml-50" : "ml-250"}
                >
                    {isMobile == true ? (
                        <div className="row mobile-head w-100 border-bottom margin-left-14px">
                            <div className="col-12">
                                <label className="text-14-bold">Applications</label>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="sub-modules col-12  border-bottom">
                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <label className="module-head  pl-20 pt-4 pb-4 pr-3">
                                                    Applications
                                                </label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                    <div
                        className={
                            isMobile ? "action-table1 wrap-role" : "action-table wrap-role "
                        }
                        style={{
                            width: isMobile
                                ? "100%"
                                : this.props.sideMenu
                                    ? "calc(100% - 50px)"
                                    : "calc(100% - 250px)",
                        }}
                    >
                        <table width="100%" className={isMobile ? "" : "  border-top"}>
                            <tbody>
                                <tr>
                                    <td width="70%" className="d-flex align-middle">
                                        <div
                                            className="d-flex cursor-pointer back-hover  pl-9 pr-5 label"
                                            onClick={this.showSearchScreen}
                                        >
                                            <img
                                                src={addapplication}
                                                className={`${isMobile380
                                                        ? "px-2 img-height-45"
                                                        : "px-2 img-height-50"
                                                    } py-3`}
                                            />
                                            <label
                                                className={`${isMobile380
                                                        ? "pt-13 px-1 text-12-normal "
                                                        : "pt-15 px-1 text-14-normal "
                                                    } cursor-pointer  pr-10`}
                                            >
                                                {isMobile380 ? "Add" : "Add application"}
                                            </label>
                                        </div>
                                        <div
                                            className={`${deleteList?.length > 0 ? `` : `pointer-none`
                                                } ${`d-flex cursor-pointer back-hover pl-9 pr-5 label`}`}
                                            data-bs-toggle="modal"
                                            data-bs-target="#deleteModal"
                                        >
                                            <img
                                                src={applicationdelete}
                                                className={`${isMobile380
                                                        ? "px-1 img-height-45"
                                                        : "px-2 img-height-50"
                                                    } ${deleteList?.length > 0 ? `` : `opacity02`} py-3`}
                                            />
                                            <label
                                                className={`${isMobile380
                                                        ? "pt-13 px-1 text-12-normal"
                                                        : "pt-15 px-1 text-14-normal "
                                                    } ${deleteList?.length > 0 ? `` : `color-img`
                                                    } cursor-pointer pr-10`}
                                            >
                                                {isMobile380 ? "Delete" : "Delete application"}
                                            </label>
                                        </div>
                                    </td>

                                    <td width="10%" className="text-end">
                                        <img
                                            src={filter}
                                            className={`${isMobile380 ? "img-height-45 p-3" : "p-3"
                                                } cursor-pointer`}
                                            onClick={this.showFilterSearch}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div
                        className={isMobile ? "sub-modules1-table" : "sub-modules-table "}
                        style={{
                            height: isMobile ? height - 200 : height - 255,
                            width: isMobile
                                ? "100%"
                                : this.props.sideMenu
                                    ? "calc(100% - 50px)"
                                    : "calc(100% - 250px)",
                        }}
                    >
                        <div className="table-responsive common-table-bottom">
                            <table width="100%" id="usersTable" className="border-collapse">
                                <thead className="border-top border-bottom border-collapse">
                                    <tr>
                                        <th
                                            className="pt-2 pad-selectbox px-3 border-top border-bottom"
                                            width="3%"
                                        >
                                            <div
                                                className="form-group-check"
                                                onClick={() => this.handleCheckboxTop()}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={
                                                        deleteList?.length > 0 &&
                                                            deleteList?.length ==
                                                            applicationList?.application?.length
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                <label htmlFor="checkbox"></label>
                                            </div>
                                        </th>
                                        <th
                                            className=" pt-2 pad-selectbox border-top border-bottom wrap-role"
                                            width={
                                                this.props.sideMenu
                                                    ? isMobile
                                                        ? "35%"
                                                        : "20%"
                                                    : isMobile
                                                        ? "30%"
                                                        : "20%"
                                            }
                                            onClick={() => this.sorting()}
                                        >
                                            <label
                                                className={
                                                    this.props.sideMenu
                                                        ? "text-12-bold cursor-pointer pr-10"
                                                        : "text-12-bold cursor-pointer pr-10 "
                                                }
                                            >
                                                Application name
                                            </label>
                                            {sortBy == "applicationname" && sortOrder ? (
                                                <img
                                                    src={SortIcon}
                                                    className={
                                                        sortOrder == "asc"
                                                            ? "cursor-pointer"
                                                            : "cursor-pointer rotate-180"
                                                    }
                                                />
                                            ) : (
                                                ""
                                            )}
                                        </th>
                                        <th
                                            className={
                                                this.props.sideMenu
                                                    ? "border-top border-bottom wrap-role"
                                                    : "pt-2  pl-17 border-top border-bottom pad-selectbox wrap-role"
                                            }
                                            width={
                                                this.props.sideMenu
                                                    ? isMobile
                                                        ? "67%"
                                                        : "77%"
                                                    : isMobile
                                                        ? "67%"
                                                        : "77%"
                                            }
                                        >
                                            <label className="text-12-bold pr-20">
                                                Application description
                                            </label>
                                        </th>
                                    </tr>
                                </thead>
                                {isLoadSpinnerTable == false && (
                                    <>
                                        <tbody>
                                            {applicationList &&
                                                applicationList?.application?.length > 0 ? (
                                                applicationList?.application?.map((i) => (
                                                    <>
                                                        <tr
                                                            key={i.applicationId}
                                                            className={`${deleteList?.filter((r) => r == i.applicationId)
                                                                    ?.length > 0 &&
                                                                    applicationEnum != i.application_enum
                                                                    ? "required-backcolor border-collapse"
                                                                    : "border-collapse"
                                                                }`}
                                                        >
                                                            <td
                                                                className={`${"align-middle border-bottom pad-selectbox1 text-center"}`}
                                                            >
                                                                {applicationEnum == i.application_enum ? (
                                                                    ""
                                                                ) : (
                                                                    <div
                                                                        className="form-group-check"
                                                                        onClick={() =>
                                                                            this.handleCheckbox(i.applicationId)
                                                                        }
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={
                                                                                deleteList?.filter(
                                                                                    (r) => r == i.applicationId
                                                                                )?.length > 0
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                        />
                                                                        <label htmlFor="checkbox"></label>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td
                                                                className={`${applicationEnum == i.application_enum
                                                                        ? "py-2"
                                                                        : ""
                                                                    } ${"border-bottom"}`}
                                                            >
                                                                <label
                                                                    className="align-middle text-12-bold cursor-pointer  text-decoration"
                                                                    onClick={() => {
                                                                        this.handleEditPage(
                                                                            i.applicationId,
                                                                            i.application_enum
                                                                        );
                                                                    }}
                                                                >
                                                                    {i.applicationName}
                                                                </label>
                                                            </td>
                                                            <td
                                                                className={
                                                                    this.props.sideMenu
                                                                        ? "border-bottom "
                                                                        : "  pl-17 border-bottom  container-multiline "
                                                                }
                                                            >
                                                                <label className="text-10-normal align-middle multiline-ellipsis">
                                                                    {i.description}
                                                                </label>
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                    </>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td className="border-bottom"></td>
                                                    <td
                                                        className={`py-2 no-content-message no-wrap border-bottom`}
                                                        colSpan={3}
                                                    >
                                                        No application found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>{" "}
                                    </>
                                )}
                            </table>
                        </div>
                    </div>
                    <div
                        className="offcanvas offcanvas-end  offcanvasStyle"
                        tabIndex={-1}
                        data-bs-scroll="false"
                        data-bs-backdrop="true"
                        id="searchScreen"
                        aria-labelledby="offcanvasScrollingLabel"
                    >
                        <div className="canvas-padding">
                            <div className="offcanvas-header pb-1">
                                <h6 className="modal-title text-20-bold pt-30 ">Search</h6>
                                <img
                                    src={crossicon}
                                    id="crossicon"
                                    className={`cursor-pointer text-reset offcavasclose ${isMobile ? "pr-0" : ""
                                        }`}
                                    data-bs-dismiss="offcanvas"
                                ></img>
                            </div>
                            <div className="offcanvas-body  scroll-css">
                                <div>
                                    <label
                                        className={
                                            isMobile
                                                ? "d-flex  m-0"
                                                : "d-flex m-0 text-left float-start"
                                        }
                                    >
                                        <img src={applicationname1}></img>
                                        <span className="pl-5 text-12-bold">Application name</span>
                                    </label>
                                    <br></br>
                                    <input
                                        type="text"
                                        maxLength={255}
                                        autoComplete="off"
                                        className="input-text input-clear pad-input text-12-normal w-95"
                                        value={this.state.applicationname}
                                        onChange={(e) =>
                                            this.handleInputSearch(e, "applicationname")
                                        }
                                    ></input>
                                </div>
                                {!isFormValid && (
                                    <p className="pt-3 message-search required-color">
                                        At least one field is mandatory
                                    </p>
                                )}
                                <button
                                    id="closeSearch"
                                    className="offcavasclose d-none"
                                    data-bs-dismiss="offcanvas"
                                ></button>
                                <div className={`${isFormValid ? "pt-3" : ""} d-flex`}>
                                    <div>
                                        <button
                                            className="action-button px-3 py-2"
                                            onClick={this.handleFilterSearch}
                                        >
                                            <img src={searchapplication} className="img-top" /> Search
                                        </button>
                                    </div>
                                    <div className="mx-3">
                                        <button
                                            className="reset-button  px-3"
                                            onClick={() => this.handleFilterClear()}
                                        >
                                            <img src={reseticon} className="img-top reset-image" />{" "}
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`${isMobile
                                ? "common-mobilesubmenu mobile-pagination"
                                : this.props.sideMenu
                                    ? "common-submenu sidemenu-pagination"
                                    : "common-submenu web-pagination"
                            } pb-2 pt-2`}
                    >
                        <table width="100%">
                            <tbody>
                                <tr>
                                    <td width="8%" className="p-3">
                                        <div
                                            className={`${isMobile380 ? "mobilePageSelect" : "webpageSelect"
                                                }`}
                                        >
                                            {this.state.applicationList?.pagination?.totalcount ? (
                                                <Select
                                                    options={paginglist}
                                                    defaultValue={paginglistDefault}
                                                    classNamePrefix="paging"
                                                    isSearchable={false}
                                                    menuPlacement={"top"}
                                                    menuPosition={"fixed"}
                                                    onChange={(e) => this.pageSize(e)}
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            boxShadow: "none", // no box-shadow
                                                        }),
                                                    }}
                                                />
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </td>
                                    <td width="92%" className="text-end p-3">
                                        {isMobile ? (
                                            this.state.applicationList?.pagination?.totalcount ? (
                                                <Pagination
                                                    prevPageText={
                                                        <>
                                                            <img src={arrowleft} />
                                                        </>
                                                    }
                                                    nextPageText={
                                                        <>
                                                            <img src={arrowright} />
                                                        </>
                                                    }
                                                    linkClassNext="nextArrow"
                                                    linkClassPrev="prevArrow"
                                                    itemClass={`page-item`}
                                                    linkClass="page-link"
                                                    pageRangeDisplayed={1}
                                                    onChange={(e) => this.handlePageChange(e)}
                                                    activePage={this.state.pagenumber}
                                                    totalItemsCount={
                                                        this.state.applicationList?.pagination?.totalcount
                                                    }
                                                    itemsCountPerPage={
                                                        this.state.applicationList?.pagination?.pageSize
                                                    }
                                                />
                                            ) : (
                                                ""
                                            )
                                        ) : this.state.applicationList?.pagination?.totalcount ? (
                                            <Pagination
                                                prevPageText={
                                                    <>
                                                        <img src={arrowleft} />
                                                    </>
                                                }
                                                nextPageText={
                                                    <>
                                                        <img src={arrowright} />
                                                    </>
                                                }
                                                linkClassNext="nextArrow"
                                                linkClassPrev="prevArrow"
                                                itemClass={`page-item`}
                                                linkClass="page-link"
                                                pageRangeDisplayed={4}
                                                onChange={(e) => this.handlePageChange(e)}
                                                activePage={this.state.pagenumber}
                                                totalItemsCount={
                                                    this.state.applicationList?.pagination?.totalcount
                                                }
                                                itemsCountPerPage={
                                                    this.state.applicationList?.pagination?.pageSize
                                                }
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div
                        className="offcanvas  offcanvas-end offcanvasStyle audit-offcanvas"
                        tabIndex={-1}
                        data-bs-scroll="false"
                        data-bs-backdrop="true"
                        id="viewScreen"
                        aria-labelledby="offcanvasScrollingLabel"
                    >
                        {isAddApp && (
                            <div className="offcanvas-header pb-1">
                                <h6 className="modal-title text-20-bold pl-15 pt-30 ">
                                    Add application
                                </h6>
                                <img
                                    src={crossicon}
                                    className={`cursor-pointer text-reset offcavasclose ${isMobile ? "pr-0" : ""
                                        }`}
                                    data-bs-dismiss="offcanvas"
                                    onClick={() => {
                                        this.setState({ isAddApp: false });
                                    }}
                                />
                            </div>
                        )}
                        {isView && (
                            <div className="offcanvas-header pb-2 pt-4">
                                <h6 className="modal-title text-20-bold pl-15">
                                    {this.state.addeditApplication.applicationName}
                                </h6>
                                <button
                                    id="clearEditYes"
                                    className="offcavasclose d-none"
                                    data-bs-dismiss="offcanvas"
                                ></button>
                                <img
                                    src={crossicon}
                                    className={`cursor-pointer text-reset offcavasclose ${isMobile ? "pr-0" : ""
                                        }`}
                                    data-bs-dismiss="offcanvas"
                                ></img>
                            </div>
                        )}
                        {isEdit && (
                            <div className="offcanvas-header pb-2 pt-4">
                                <h6
                                    id="offcanvasRightLabel"
                                    className="modal-title pl-15 text-20-bold"
                                >
                                    {this.state.applicationHeading}
                                </h6>
                                <div
                                    className="d-flex cursor-pointer pl-9 label"
                                    data-bs-toggle="modal"
                                    data-bs-target="#alert"
                                >
                                    <button
                                        id="clearEditYes"
                                        className="offcavasclose d-none"
                                        data-bs-dismiss="offcanvas"
                                    ></button>
                                    <img
                                        src={crossicon}
                                        className={`cursor-pointer text-reset offcanvasclose ${isMobile ? "pr-0" : ""
                                            }`}
                                    ></img>
                                </div>
                            </div>
                        )}
                        <div className="canvas-padding scroll scroll-css">
                            {isAddApp && (
                                <>
                                    <div className="offcanvas-body top ">
                                        <div className="row">
                                            <div>
                                                <div className="mb-1">
                                                    <label>
                                                        <img src={applicationname1}></img>
                                                        <span className="pl-5 text-12-bold">
                                                            Application name&nbsp;
                                                            <span className="required-color">*</span>
                                                        </span>
                                                    </label>
                                                </div>
                                                <input
                                                    type="text"
                                                    maxLength={255}
                                                    autoComplete="off"
                                                    className={`${this.state.applicationNameError ||
                                                            this.state.applicationExists
                                                            ? `border-input`
                                                            : ``
                                                        } ${`pad-input text-12-normal input-text w-95`}`}
                                                    value={
                                                        this.state.addeditApplication.applicationName &&
                                                        this.state.addeditApplication.applicationName
                                                    }
                                                    onChange={(e) =>
                                                        this.handleInputAddEdit(e, "applicationName")
                                                    }
                                                    id="applicationNameId"
                                                ></input>
                                                <br></br>
                                                {(this.state.applicationNameError ||
                                                    this.state.applicationExists) && (
                                                        <>
                                                            <img src={RequiredIcon} />
                                                            &nbsp;
                                                            <label className="required">
                                                                {this.state.applicationExists
                                                                    ? "The Application name is already existing"
                                                                    : "Required"}
                                                            </label>
                                                        </>
                                                    )}
                                            </div>
                                            <div className="mt-1">
                                                <div className="mb-1">
                                                    <label>
                                                        <img src={applicationurl}></img>
                                                        <span className="pl-5 text-12-bold">
                                                            Application url
                                                        </span>
                                                    </label>
                                                </div>
                                                <input
                                                    type="text"
                                                    maxLength={255}
                                                    autoComplete="off"
                                                    className="pad-input text-12-normal input-text w-95"
                                                    value={this.state.addeditApplication.appUrl}
                                                    onChange={(e) => this.handleInputAddEdit(e, "appUrl")}
                                                ></input>
                                            </div>
                                            <div className="mt-1">
                                                <div className="mb-1">
                                                    <label>
                                                        <img src={applicationdescription}></img>
                                                        <span className="pl-5 text-12-bold">
                                                            Application description
                                                        </span>
                                                    </label>
                                                </div>
                                                <textarea
                                                    rows="3"
                                                    className="pad-para text-12-normal input-textarea w-100"
                                                    value={this.state.addeditApplication.description}
                                                    onChange={(e) =>
                                                        this.handleInputAddEdit(e, "description")
                                                    }
                                                ></textarea>
                                            </div>
                                            <div className="pt-18">
                                                <button
                                                    type="button"
                                                    className="applicationbtn"
                                                    data-bs-dismiss={this.state.isAddHide && "offcanvas"}
                                                    onClick={this.handleAddEdit}
                                                >
                                                    <img
                                                        className="image-height-12 plus-image"
                                                        src={saveapplication}
                                                    ></img>
                                                    &nbsp;Save
                                                </button>
                                                <button
                                                    data-bs-dismiss="offcanvas"
                                                    id="addEditApplication"
                                                    className="d-none"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                            {isView && !isLoadSpinner && (
                                <>
                                    {isLoadSpinner == false && (
                                        <>
                                            <div className="offcanvas-body ">
                                                <div className="row ">
                                                    <>
                                                        <div className="pb-3">
                                                            <div
                                                                onClick={() => {
                                                                    this.handleEditApplication();
                                                                }}
                                                                data-bs-dismiss="offcanvas"
                                                            >
                                                                <label
                                                                    className={
                                                                        isMobile
                                                                            ? "d-flex  m-0 text-left float-start cursor-pointer"
                                                                            : "d-flex m-0 text-left float-start cursor-pointer"
                                                                    }
                                                                >
                                                                    <img src={editiconred}></img>
                                                                    <span className="pl-5 text-12-bold  underline">
                                                                        Edit
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            {applicationEnum == this.state.applicationEnum ? (
                                                                ""
                                                            ) : (
                                                                <div>
                                                                    <label
                                                                        className={
                                                                            isMobile
                                                                                ? "d-flex  m-0 cursor-pointer"
                                                                                : "d-flex m-0 text-left float-start cursor-pointer"
                                                                        }
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#deleteModalViewDelete"
                                                                    >
                                                                        <img
                                                                            className="pl-17"
                                                                            src={DeleteIcon}
                                                                        ></img>
                                                                        <span className="pl-5 text-12-bold  underline">
                                                                            Delete
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div>
                                                            <label
                                                                className={
                                                                    isMobile
                                                                        ? "d-flex  m-0"
                                                                        : "d-flex m-0 text-left float-start col-9"
                                                                }
                                                            >
                                                                <img src={applicationname1}></img>
                                                                <span className="pl-5 text-12-bold">
                                                                    Application name
                                                                </span>
                                                            </label>
                                                            <p className="col-9 text-12-normal">
                                                                {this.state.addeditApplication.applicationName}
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <label
                                                                className={
                                                                    isMobile
                                                                        ? "d-flex  m-0"
                                                                        : "d-flex m-0 text-left float-start col-9"
                                                                }
                                                            >
                                                                <img src={applicationurl}></img>
                                                                <span className="pl-5 text-12-bold">
                                                                    Application url
                                                                </span>
                                                            </label>
                                                            <p
                                                                className={
                                                                    this.state.addeditApplication.appUrl
                                                                        ? "col-9 text-12-normal view-text"
                                                                        : "pb-3"
                                                                }
                                                            >
                                                                {this.state.addeditApplication.appUrl}
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <label
                                                                className={
                                                                    isMobile
                                                                        ? "d-flex  m-0"
                                                                        : "d-flex m-0 text-left float-start col-11"
                                                                }
                                                            >
                                                                <img src={applicationdescription}></img>
                                                                <span className="pl-5 text-12-bold">
                                                                    Application description
                                                                </span>
                                                            </label>
                                                            <p
                                                                className={
                                                                    this.state.addeditApplication.description
                                                                        ? "col-11 text-12-normal view-text"
                                                                        : "pb-3"
                                                                }
                                                            >
                                                                {this.state.addeditApplication.description}
                                                            </p>
                                                        </div>
                                                        <div className="col-12 pb-1">
                                                            <label
                                                                className={
                                                                    isMobile
                                                                        ? "d-flex  m-0"
                                                                        : "d-flex m-0 text-left float-start"
                                                                }
                                                            >
                                                                <img src={roles}></img>
                                                                <span className="pl-5 text-12-bold">Roles</span>
                                                            </label>
                                                        </div>
                                                        <div>
                                                            <div
                                                                className={`${isEdit == true ? `roles-height` : ``
                                                                    } ${isMobile300
                                                                        ? "row pr-20 scroll scroll-editrole sample"
                                                                        : isMobile380
                                                                            ? "row pr-20 scroll  scroll-editrole  sample-380"
                                                                            : "row pr-20 scroll scroll-editrole "
                                                                    }`}
                                                                style={{ overflowY: "hidden" }}
                                                            >
                                                                <div
                                                                    className={
                                                                        isMobile380
                                                                            ? "col-5  margin-right0 padding-right0 border-right"
                                                                            : "col-3 margin-right0 padding-right0 border-right"
                                                                    }
                                                                >
                                                                    <table width="100%">
                                                                        <tbody>
                                                                            {this.state.addeditApplication?.users
                                                                                ?.length > 0 ? (
                                                                                <>
                                                                                    {this.state.addeditApplication?.users?.map(
                                                                                        (r) => (
                                                                                            <>
                                                                                                <tr
                                                                                                    className="cursor-pointer text-center"
                                                                                                    onClick={() => {
                                                                                                        this.roleChangeId(
                                                                                                            r.roleId,
                                                                                                            r.roleName
                                                                                                        );
                                                                                                    }}
                                                                                                >
                                                                                                    <td
                                                                                                        className={`${r.roleId ==
                                                                                                                this.state.roleId
                                                                                                                ? "role-background"
                                                                                                                : ""
                                                                                                            } py-2 px-2 text-12-normal border-bottom  `}
                                                                                                    >
                                                                                                        {r.roleName}
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </>
                                                                                        )
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div
                                                                    className={
                                                                        this.state.addeditApplication?.users
                                                                            ?.length > 0
                                                                            ? isMobile380
                                                                                ? "col-7 p-0"
                                                                                : "col-9 p-0"
                                                                            : "col-9"
                                                                    }
                                                                >
                                                                    {/* view table */}
                                                                    <table
                                                                        width={isMobile380 ? "" : "100%"}
                                                                        className="px-2 "
                                                                    >
                                                                        <thead>
                                                                            {this.state.addeditApplication?.users
                                                                                ?.length > 0 ? (
                                                                                <>
                                                                                    <tr className="cursor-pointer pl-0 align-middle">
                                                                                        <td
                                                                                            className="py-2 px-2 text-12-normal border-bottom align-middle border-top"
                                                                                            width="40%"
                                                                                        >
                                                                                            Name
                                                                                        </td>
                                                                                        <td
                                                                                            className="py-2 px-2 text-12-normal border-bottom align-middle border-top"
                                                                                            width="60%"
                                                                                        >
                                                                                            Email
                                                                                        </td>
                                                                                    </tr>
                                                                                </>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </thead>
                                                                        <tbody>
                                                                            {this.state.addeditApplication?.users?.map(
                                                                                (t) => (
                                                                                    <>
                                                                                        {this.state.roleId == t.roleId ? (
                                                                                            t.users?.map((s) => (
                                                                                                <tr className="cursor-pointer pl-0 align-middle">
                                                                                                    <td className="py-2 px-2 text-10-normal border-bottom align-middle white-nowrap">
                                                                                                        <img
                                                                                                            src={ManagerDropIcon}
                                                                                                            className="pr-10"
                                                                                                        />
                                                                                                        {s.value}
                                                                                                    </td>
                                                                                                    <td className="py-2 px-2 text-10-normal border-bottom align-middle ">
                                                                                                        {s.name}
                                                                                                    </td>
                                                                                                </tr>
                                                                                            ))
                                                                                        ) : (
                                                                                            <></>
                                                                                        )}
                                                                                    </>
                                                                                )
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {isView &&
                                                            this.state.addeditApplication?.historyLogs?.length > 0 && (
                                                                <div>
                                                                    <div className="pt-4">
                                                                        <h6 className="text-20-bold">Audit log</h6>
                                                                    </div>
                                                                    <div className="audit-table-wrapper audit-scroll-css table-fixed-header">
                                                                        <table className="px-3 audit-table">
                                                                            <thead>
                                                                                <tr className="border-bottom">
                                                                                    <th className="p-rem">Action</th>
                                                                                    <th className="p-rem w-23">Action By</th>
                                                                                    <th className="p-rem wid-45">Description</th>
                                                                                    <th className="p-rem">Date</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {this.state.addeditApplication?.historyLogs.map(
                                                                                    (x) => (
                                                                                        <tr className="border-bottom">
                                                                                            <td className="p-rem align-top">
                                                                                                {x.action && x.action}
                                                                                            </td>
                                                                                            <td className="p-rem align-top">
                                                                                                {x.actionBy && x.actionBy}
                                                                                            </td>
                                                                                            <td className="p-rem">{x.description && x.description}</td>
                                                                                            <td className="p-rem align-top">
                                                                                                {x.createdTime && moment
                                                                                                    .utc(x.createdTime)
                                                                                                    .local()
                                                                                                    .format("DD-MMM-YYYY hh:mm A")}
                                                                                                {/* {moment(x.createdTime).format("DD-MMM-YYYY, h:mm A")} */}
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            )}
                                                    </>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                            {isEdit && (
                                <>
                                    <div className="offcanvas-body">
                                        <div className="row">
                                            <>
                                                <div className="mar-top pb-0">
                                                    <label
                                                        className={
                                                            isMobile
                                                                ? "d-flex  m-0 pb-1"
                                                                : "pb-1 d-flex m-0 text-left float-start col-9"
                                                        }
                                                    >
                                                        <img src={applicationname1}></img>
                                                        <span className="pl-5 text-12-bold">
                                                            Application name
                                                        </span>
                                                    </label>
                                                    {/* <input
                            type="text"
                            maxLength={255}
                            autoComplete="off"
                            className={`${this.state.applicationNameError ? `border-input` : ``} ${`pad-input w-95`}`}
                            value={
                              this.state.addeditApplication.applicationName
                            }
                            onChange={(e) =>
                              this.handleInputAddEdit(e, "applicationName")
                            }
                          ></input>
                          <br></br>
                          {this.state.applicationNameError && (
                            <>
                              <img src={RequiredIcon} />
                              &nbsp;<label className="required">Required</label>
                            </>
                          )} */}
                                                    <p className="col-9 text-12-normal">
                                                        {this.state.addeditApplication.applicationName}
                                                    </p>
                                                </div>
                                                <div className="pb-3">
                                                    <label
                                                        className={
                                                            isMobile
                                                                ? "d-flex  m-0 pb-1"
                                                                : "pb-1 d-flex m-0 text-left float-start"
                                                        }
                                                    >
                                                        <img src={applicationurl}></img>
                                                        <span className="pl-5 text-12-bold">
                                                            Application url
                                                        </span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        maxLength={255}
                                                        autoComplete="off"
                                                        className=" pad-input  text-12-normal align-middle text"
                                                        value={this.state.addeditApplication.appUrl}
                                                        onChange={(e) =>
                                                            this.handleInputAddEdit(e, "appUrl")
                                                        }
                                                    ></input>
                                                </div>
                                                <div className="pb-3">
                                                    <label
                                                        className={
                                                            isMobile
                                                                ? "d-flex  m-0 pb-1"
                                                                : "pb-1 d-flex m-0 text-left float-start"
                                                        }
                                                    >
                                                        <img src={applicationdescription}></img>
                                                        <span className="pl-5 text-12-bold">
                                                            Application description
                                                        </span>
                                                    </label>
                                                    <textarea
                                                        rows="3"
                                                        className="pad-para  input-textarea text-12-normal"
                                                        value={this.state.addeditApplication.description}
                                                        onChange={(e) =>
                                                            this.handleInputAddEdit(e, "description")
                                                        }
                                                    ></textarea>
                                                </div>
                                                <div className={isMobile380 ? "" : "col-12 pb-1"}>
                                                    <label
                                                        className={
                                                            isMobile
                                                                ? "d-flex  m-0"
                                                                : "d-flex m-0 text-left float-start"
                                                        }
                                                    >
                                                        <img src={roles}></img>
                                                        <span className="pl-5 text-12-bold">Roles</span>
                                                    </label>
                                                </div>
                                                <div
                                                    className={
                                                        isMobile380
                                                            ? "row pr-20 sample mobile-view scroll  scroll-editrole "
                                                            : "row pr-20 scroll  scroll-editrole "
                                                    }
                                                >
                                                    <div
                                                        className={
                                                            isMobile380
                                                                ? " col-5  margin-right0 padding-right0 border-right "
                                                                : "col-3 margin-right0 padding-right0 border-right"
                                                        }
                                                    >
                                                        <table width={isMobile380 ? "100%" : "100%"}>
                                                            <tbody>
                                                                {this.state.addeditApplication?.users?.map(
                                                                    (r) => (
                                                                        <>
                                                                            <tr
                                                                                className="cursor-pointer text-center"
                                                                                onClick={() => {
                                                                                    this.roleChangeId(
                                                                                        r.roleId,
                                                                                        r.roleName
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <td
                                                                                    className={`${r.roleId == this.state.roleId
                                                                                            ? "role-background"
                                                                                            : ""
                                                                                        } py-2 px-2 text-12-normal border-bottom  `}
                                                                                >
                                                                                    {r.roleName}
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div
                                                        className={
                                                            this.state.addeditApplication?.users?.length > 0
                                                                ? isMobile380
                                                                    ? "col-7 p-0"
                                                                    : "col-9 p-0"
                                                                : "col-9"
                                                        }
                                                    >
                                                        {/* edit table */}

                                                        <table
                                                            width={isMobile380 ? "" : "100%"}
                                                            className="px-2 "
                                                        >
                                                            {this.state.addeditApplication?.users?.length >
                                                                0 ? (
                                                                <>
                                                                    <thead className="roles-head table2">
                                                                        <tr className="cursor-pointer pl-0">
                                                                            <td
                                                                                className="py-2 px-2 text-12-normal"
                                                                                colSpan={3}
                                                                            >
                                                                                {this.state.addeditApplication?.deleteAppUser?.filter(
                                                                                    (r) => r.roleId == this.state.roleId
                                                                                )[0]?.userId?.length > 0 ? (
                                                                                    <div
                                                                                        className="py-2 cursor-pointer"
                                                                                        onClick={this.handleRoleIdRemove}
                                                                                    >
                                                                                        <img src={DeleteIcon}></img>
                                                                                        &nbsp;&nbsp;Remove
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="cursor-pointer">
                                                                                        <Select
                                                                                            classNamePrefix="roles"
                                                                                            value={[]}
                                                                                            options={this.state.rolesList}
                                                                                            placeholder={
                                                                                                <div>
                                                                                                    <img
                                                                                                        src={plusred}
                                                                                                        className="img-top"
                                                                                                    />
                                                                                                    &nbsp;&nbsp;{" "}
                                                                                                    {"Add " + this.state.roleName}
                                                                                                </div>
                                                                                            }
                                                                                            defaultValue={[]}
                                                                                            isMulti={true}
                                                                                            isSearchable={true}
                                                                                            className="cursor-pointer"
                                                                                            onChange={this.handlerolesAction}
                                                                                            onFocus={this.handleFocus}
                                                                                            onBlur={this.handleBlur}
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                        <tr
                                                                            className="cursor-pointer pl-0  border-top"
                                                                            width="10%" // align-middle
                                                                        >
                                                                            <td className="py-2 px-2 text-12-normal border-bottom">
                                                                                <div
                                                                                    className="form-group-check"
                                                                                    onClick={() =>
                                                                                        this.handleCheckboxRolesAll()
                                                                                    }
                                                                                >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={
                                                                                            this.state.addeditApplication?.deleteAppUser?.filter(
                                                                                                (r) =>
                                                                                                    r.roleId == this.state.roleId
                                                                                            )[0]?.userId?.length > 0 &&
                                                                                                this.state.addeditApplication?.deleteAppUser?.filter(
                                                                                                    (r) =>
                                                                                                        r.roleId == this.state.roleId
                                                                                                )[0]?.userId?.length ==
                                                                                                this.state.addeditApplication?.users?.filter(
                                                                                                    (r) =>
                                                                                                        r.roleId ==
                                                                                                        this.state.roleId
                                                                                                )[0]?.users?.length
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                    />
                                                                                    <label htmlFor="checkbox"></label>
                                                                                </div>
                                                                            </td>
                                                                            <td
                                                                                className="py-2 px-2 align-middle text-12-normal border-bottom  border-top"
                                                                                width="40%"
                                                                            >
                                                                                Name
                                                                            </td>
                                                                            <td
                                                                                id="app-edit-email-pad"
                                                                                className="py-2 px-2 align-middle text-12-normal border-bottom  border-top text-centre"
                                                                                width="50%"
                                                                            >
                                                                                Email
                                                                            </td>
                                                                        </tr>
                                                                    </thead>
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )}
                                                            <tbody

                                                                className={
                                                                    isMobile380
                                                                        ? "table2 roles-table scroll-editrole"
                                                                        : "roles-table scroll-editrole"
                                                                }
                                                            >
                                                                {this.state.addeditApplication?.users?.map(
                                                                    (t) => (
                                                                        <>
                                                                            {this.state.roleId == t.roleId ? (
                                                                                t.users?.map((s) => (
                                                                                    <tr
                                                                                        className="cursor-pointer pl-0  "
                                                                                    //align-middle
                                                                                    >
                                                                                        <td
                                                                                            className="py-2 px-2 text-12-normal border-bottom"
                                                                                            width="10%"
                                                                                        >
                                                                                            {s.id ==
                                                                                                localStorage.getItem("userId") ? (
                                                                                                ""
                                                                                            ) : (
                                                                                                <div
                                                                                                    className="form-group-check"
                                                                                                    onClick={() =>
                                                                                                        this.handleCheckboxRoles(
                                                                                                            s.id
                                                                                                        )
                                                                                                    }
                                                                                                >
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        checked={
                                                                                                            this.state.addeditApplication?.deleteAppUser
                                                                                                                ?.filter(
                                                                                                                    (r) =>
                                                                                                                        r.roleId ==
                                                                                                                        this.state.roleId
                                                                                                                )[0]
                                                                                                                ?.userId?.filter(
                                                                                                                    (r) => r == s.id
                                                                                                                )?.length > 0
                                                                                                                ? true
                                                                                                                : false
                                                                                                        }
                                                                                                    />
                                                                                                    <label htmlFor="checkbox"></label>
                                                                                                </div>
                                                                                            )}
                                                                                        </td>
                                                                                        <td className="align-middle py-2 px-2 text-10-normal border-bottom white-nowrap">
                                                                                            <img
                                                                                                src={ManagerDropIcon}
                                                                                                className="pr-10"
                                                                                            />
                                                                                            {s.value}
                                                                                        </td>
                                                                                        <td className="align-middle py-2 px-2 text-10-normal border-bottom ">
                                                                                            {s.name}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))
                                                                            ) : (
                                                                                <></>
                                                                            )}
                                                                        </>
                                                                    )
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <button
                                                        className="savechangebtn"
                                                        type="button"
                                                        data-bs-dismiss={
                                                            this.state.isAddHide && "offcanvas"
                                                        }
                                                        onClick={this.handleAddEdit}
                                                    >
                                                        <img src={saveapplication}></img>
                                                        <span className="text-12-normal">Save changes</span>
                                                    </button>
                                                </div>
                                            </>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div
                        id="alert"
                        className="modal fade modal-top"
                        tabIndex="-1"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-all">
                            <div className="modal-content px-4">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="px-1 py-3 align-middle border-bottom-modal">
                                            <img src={FailedIcon} className="top-margin" />
                                            <label className="modal-title text-20-bold pl-10">
                                                Warning
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <label className="text-16-bold pt-3">
                                            Are you sure you want to close?
                                        </label>
                                    </div>
                                    <div>
                                        <label className="text-12-normal py-3">
                                            All the information you have entered for your application
                                            will be lost.
                                        </label>
                                    </div>
                                </div>
                                <div className="py-3 text-center">
                                    <button
                                        className="cancel-button text-12-bold px-4 py-2"
                                        data-bs-dismiss="modal"
                                    >
                                        No
                                    </button>
                                    <button
                                        className="success-button text-12-bold px-4 py-2 ml-10"
                                        data-bs-dismiss="modal"
                                        onClick={this.CancelYes}
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        id="deleteModal"
                        className="modal fade modal-top"
                        tabIndex="-1"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-all">
                            <div className="modal-content px-4">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="px-1 py-3 align-middle border-bottom-modal">
                                            <img src={FailedIcon} className="top-margin" />
                                            <label className="modal-title text-20-bold pl-10">
                                                Warning
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <label className="text-16-bold pt-3">
                                            Are you sure you want to remove the application?
                                        </label>
                                    </div>
                                    <div>
                                        <label className="text-12-normal py-3">
                                            All the information about the application will be lost.
                                        </label>
                                    </div>
                                </div>
                                <div className="py-3 text-center">
                                    <button
                                        className="cancel-button text-12-bold px-4 py-2"
                                        data-bs-dismiss="modal"
                                    >
                                        No
                                    </button>
                                    <button
                                        className="success-button text-12-bold px-4 py-2 ml-10"
                                        data-bs-dismiss="modal"
                                        onClick={this.DeleteYes}
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        id="deleteModalViewDelete"
                        className="modal fade modal-top"
                        tabIndex="-1"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-all">
                            <div className="modal-content px-4">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="px-1 py-3 align-middle border-bottom-modal">
                                            <img src={FailedIcon} className="top-margin" />
                                            <label className="modal-title text-20-bold pl-10">
                                                Warning
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <label className="text-16-bold pt-3">
                                            Are you sure you want to remove the application?
                                        </label>
                                    </div>
                                    <div>
                                        <label className="text-12-normal py-3">
                                            All the information about the application will be lost.
                                        </label>
                                    </div>
                                </div>
                                <div className="py-3 text-center">
                                    <button
                                        className="cancel-button text-12-bold px-4 py-2"
                                        data-bs-dismiss="modal"
                                    >
                                        No
                                    </button>
                                    <button
                                        className="success-button text-12-bold px-4 py-2 ml-10"
                                        data-bs-dismiss="modal"
                                        onClick={this.DeleteYesViewDelete}
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        id="application"
                        className="modal fade modal-top"
                        tabIndex="-1"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-all">
                            <div className="modal-content px-4">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="px-1 py-3 align-middle border-bottom-modal">
                                            <img src={FailedIcon} className="top-margin" />
                                            <label className="modal-title text-20-bold pl-10">
                                                Warning
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <label className="text-16-bold pt-3">
                                            Are you sure you want to close?
                                        </label>
                                    </div>
                                    <div>
                                        <label className="text-12-normal py-3">
                                            All the information you have entered for your application
                                            will be lost.
                                        </label>
                                    </div>
                                </div>
                                <div className="py-3 text-center">
                                    <button
                                        className="cancel-button text-12-bold"
                                        data-bs-dismiss="modal"
                                    >
                                        No
                                    </button>
                                    <button
                                        className="success-button text-12-bold ml-10"
                                        data-bs-dismiss="modal"
                                        onClick={this.handleAddApplication}
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ToastMessageFailure
                        messageShow={isUpdateFailure || isAddFailure || isDeleteFail}
                        isMobile={isMobile}
                        messageText={
                            (isAddFailure && "Application failed to save") ||
                            (isUpdateFailure && "Application failed to update") ||
                            (isDeleteFail && "Application failed to delete")
                        }
                        handleClose={() => this.cancelToastMessage()}
                    />

                    <ToastMessageSuccess
                        messageShow={isAddSuccess || isUpdateSuccess || isDelete}
                        isMobile={isMobile}
                        messageText={
                            (isAddSuccess && "Application saved successfully") ||
                            (isUpdateSuccess && "Application updated successfully") ||
                            (isDelete && "Application deleted successfully")
                        }
                        handleClose={() => this.cancelToastMessage()}
                    />
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return { dispatch };
}

function mapStateToProps(state) {
    return {
        sideMenu: state.commonReducer.sideMenu,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Application)
);
